import { render } from "./LoginStatus.vue?vue&type=template&id=7e6f8dfc"
import script from "./LoginStatus.vue?vue&type=script&lang=js"
export * from "./LoginStatus.vue?vue&type=script&lang=js"
script.render = render

export default script